import { envConfig } from "../../config/env.config";
import * as signalR from "@microsoft/signalr";

// Biến connection toàn cục (dùng chung toàn app)
let connection: signalR.HubConnection | null = null;

/**
 * Kết nối SignalR với token (chỉ gọi 1 lần)
 */
export async function connectSignal(token: string) {
  // Nếu đã kết nối rồi thì bỏ qua
  if (connection && connection.state === signalR.HubConnectionState.Connected) {
    console.log("🔄 SignalR already connected");
    return connection;
  }
  const baseURL = envConfig.SIGNALR_ENDPOINT;

  connection = new signalR.HubConnectionBuilder()
    .withUrl(baseURL, {
      accessTokenFactory: () => token
    })
    .withAutomaticReconnect()
    .build();

  try {
    await connection
      .start()
      .then(() => console.log("Connected!"))
      .catch(err => console.error("Error connecting:", err));
  } catch (error) {
    console.error("❌ SignalR connection failed:", error);
  }

  return connection;
}

/**
 * Lấy connection hiện tại (nếu có)
 */
export function getSignalConnection() {
  return connection;
}

/**
 * Ngắt kết nối SignalR
 */
export async function disconnectSignal() {
  if (connection) {
    await connection.stop();
    console.log("🔌 SignalR disconnected");
    connection = null;
  }
}
